import { ClearVerifyStaffRole } from '@clearverify/constants';
/**
 * The `PlatformStaff` columns for a role and the financial-report checkboxes. A Manager gets no
 * financial-report access, and the monthly report needs Financial reports, whatever was sent.
 */
export const resolveClearVerifyStaffAccess = (access) => {
    const isAdmin = access.role !== ClearVerifyStaffRole.Manager;
    const isFinancialReportAvailable = isAdmin && access.isFinancialReportAvailable;
    const role = isAdmin ? 'Platform_Admin' : 'Platform_Manager';
    return {
        role,
        isAbleToManagePlatformStaff: access.role === ClearVerifyStaffRole.Super_Admin,
        isFinancialReportAvailable,
        isRecipientForMonthlyFinancialReport: isFinancialReportAvailable && access.isRecipientForMonthlyFinancialReport,
    };
};
/** The role of a stored staff row, the inverse of `resolveClearVerifyStaffAccess`. */
export const toClearVerifyStaffRole = (staff) => {
    if (staff.role === 'Platform_Manager')
        return ClearVerifyStaffRole.Manager;
    return staff.isAbleToManagePlatformStaff
        ? ClearVerifyStaffRole.Super_Admin
        : ClearVerifyStaffRole.Admin;
};
//# sourceMappingURL=clearVerifyStaff.js.map